import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DEFAULT_USA_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { FILTER_PATTERNS } from '@shared/constants';

export const getClerkRegisterProbateFormControls = (
  fb: NonNullableFormBuilder,
) => {
  return {
    userId: fb.control(0),
    isFirm: fb.control(false),
    email: fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.email)],
    }),

    firstName: fb.control('', {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(FILTER_PATTERNS.name),
      ],
    }),
    middleName: fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.name)],
    }),
    lastName: fb.control('', {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(FILTER_PATTERNS.name),
      ],
    }),
    phoneNumber: fb.control('', {
      validators: [Validators.pattern(FILTER_PATTERNS.phoneNumberFormatted)],
    }),
    username: fb.control('', {
      validators: [Validators.required, Validators.minLength(2)],
    }),
    prefixPhone: fb.control<string>(DEFAULT_USA_PHONE_PREFIX),
  };
};
